import React from 'react'

import './StandComponent.scss'
import {PdvModel} from "../../Models/PdvModel";
import {useTranslation} from "react-i18next";

interface MenuStandProps {
    stand: PdvModel,
    porte: string,
    handleClick: () => void
}

const StandComponent: React.FC<MenuStandProps> = ({stand, porte, handleClick}: MenuStandProps) => {
    const {t} = useTranslation('stands')
    return (
        <div className="standComponent" onClick={handleClick}>
            <div className="standComponent__infos">
                <p className="standComponent__infos--name">{stand.name}</p>
                <p className="standComponent__infos--porte">{t('doorLabel', {porte})}</p>
            </div>
            <div className="standComponent__img">
                {stand.image && <img className="standComponent--img" src={stand.image} alt="stand"/>}
            </div>
        </div>
    )
}

export default StandComponent;
